/**
 * Fiskal Cloud Admin Archiving Usage API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { RevokeDeletionBodyDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface AdminRevokeDeletionBusinessPremisesRequestParams {
    businessPremisesId: string;
    ifMatch: string;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO;
}

export class ClsAdminRevokeDeletionBusinessPremisesRequestParams {
    businessPremisesId: string = undefined;
    ifMatch: string = undefined;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO = undefined;
}

export interface AdminRevokeDeletionOrganizationRequestParams {
    organizationId: string;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO;
}

export class ClsAdminRevokeDeletionOrganizationRequestParams {
    organizationId: string = undefined;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO = undefined;
}

export interface AdminRevokeDeletionTenantRequestParams {
    tenantId: string;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO;
}

export class ClsAdminRevokeDeletionTenantRequestParams {
    tenantId: string = undefined;
    revokeDeletionBodyDTO: RevokeDeletionBodyDTO = undefined;
}


export interface AdminRetentionApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Revoke upcoming deletion of archived data and request an extension instead.
     * Revoke a confirmed deletion of data from the given year of origin of the business premises.  Set a new extension of the data retention instead. Admin endpoint allows to revoke the deletion after the start of the year the data should be deleted,  before the actual data deletion job would run. 
* @param requestParameters
     */
    adminRevokeDeletionBusinessPremises(requestParameters: AdminRevokeDeletionBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Revoke upcoming deletion of archived data and request an extension instead.
     * Revoke a confirmed deletion of data from the given year of origin of the business premises.  Set a new extension of the data retention instead. Admin endpoint allows to revoke the deletion after the start of the year the data should be deleted,  before the actual data deletion job would run. 
* @param requestParameters
     */
    adminRevokeDeletionOrganization(requestParameters: AdminRevokeDeletionOrganizationRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Revoke upcoming deletion of archived data and request an extension instead.
     * Revoke a confirmed deletion of data from the given year of origin of the business premises.  Set a new extension of the data retention instead. Admin endpoint allows to revoke the deletion after the start of the year the data should be deleted,  before the actual data deletion job would run. 
* @param requestParameters
     */
    adminRevokeDeletionTenant(requestParameters: AdminRevokeDeletionTenantRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
